import { render, staticRenderFns } from "./ChatflowEditor.vue?vue&type=template&id=32553acc&scoped=true"
import script from "./ChatflowEditor.vue?vue&type=script&lang=js"
export * from "./ChatflowEditor.vue?vue&type=script&lang=js"
import style0 from "./ChatflowEditor.vue?vue&type=style&index=0&id=32553acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32553acc",
  null
  
)

export default component.exports